import z from "zod";
export const ConnectorErrorSchema = z.object({
    code: z.string().min(1),
    message: z.string().min(1),
    retryable: z.boolean(),
});
//# sourceMappingURL=connector-error.schema.js.map